import { PageShell } from "../components/PageShell";
import { ResearchWidget } from "../components/ResearchWidget";
import { IntegrationsWidget } from "../components/IntegrationsWidget";

export const ResearchPage = () => {
  return (
    <PageShell
      pageTitle="Research & Integrations"
      subtitle="AI, Web3, and technology research insights, plus integration profit opportunities"
      breadcrumbs={[
        { label: "Home", href: "/" },
        { label: "Service System", href: "/" },
        { label: "Research & Integrations" }
      ]}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <IntegrationsWidget />
        <ResearchWidget />
      </div>
    </PageShell>
  );
};
